/*
 --------------------
 VIDEO PLAYER
 --------------------

 A single instance of a Video Player */

class videoPlayer {
  constructor(options, manager) {
    this.initialisePlayer = this.initialisePlayer.bind(this);
    this.identifyElements = this.identifyElements.bind(this);
    this.ima3FetchCallback = this.ima3FetchCallback.bind(this);
    this.ixFetchCallback = this.ixFetchCallback.bind(this);
    this.adtechReadyCallback = this.adtechReadyCallback.bind(this);
    this.modifyUserInitiatedTargeting = this.modifyUserInitiatedTargeting.bind(this);
    this.modifyAdserverUrlWithTargeting = this.modifyAdserverUrlWithTargeting.bind(
      this
    );
    this.modifyAdserverUrlWithIxWrapper = this.modifyAdserverUrlWithIxWrapper.bind(
      this
    );
    this.allTechReadyGo = this.allTechReadyGo.bind(this);

    this.callbackPlay = this.callbackPlay.bind(this);
    this.callbackVideoEnded = this.callbackVideoEnded.bind(this);
    this.readyUpFrontend = this.readyUpFrontend.bind(this);
    this.callbackLoadMetadataFinished = this.callbackLoadMetadataFinished.bind(
      this
    );
    this.callbackAdsStarted = this.callbackAdsStarted.bind(this);
    this.callbackAdsEnded = this.callbackAdsEnded.bind(this);
    this.callbackFirstTimeIsPlayable = this.callbackFirstTimeIsPlayable.bind(
      this
    );
    this.callbackTimeUpdate = this.callbackTimeUpdate.bind(this);
    this.callbackFirstTimePlay = this.callbackFirstTimePlay.bind(this);

    this.startAutoplayCountdown = this.startAutoplayCountdown.bind(this);
    this.setUpIntersectionObservers = this.setUpIntersectionObservers.bind(
      this
    );
    this.intersectionCallback = this.intersectionCallback.bind(this);
    this.setUpResizeListener = this.setUpResizeListener.bind(this);
    this.resizeCallback = this.resizeCallback.bind(this);
    this.buildUpNext = this.buildUpNext.bind(this);
    this.tickUpNext = this.tickUpNext.bind(this);
    this.fetchPlaylist = this.fetchPlaylist.bind(this);

    this.manager = manager;

    this.playerID = typeof (options.playerID !== 'undefined')
      ? options.playerID
      : false;

    this.accountID = typeof (options.accountID !== 'undefined')
      ? options.accountID
      : false;

    this.videoID = typeof (options.videoID !== 'undefined')
      ? options.videoID
      : false;

    this.videoIDs = typeof (options.videoIDs !== 'undefined')
      ? options.videoIDs
      : [];

    this.playlistID = typeof (options.playlistID !== 'undefined')
      ? options.playlistID
      : false;

    this.adserverUrl = typeof (options.adserverUrl !== 'undefined')
      ? options.adserverUrl
      : false;

    this.controls = typeof (options.controls !== 'undefined')
      ? options.controls
      : false;

    this.autoplay = typeof (options.autoplay !== 'undefined')
      ? options.autoplay
      : false;

    this.countdown = typeof (options.countdown !== 'undefined')
      ? options.countdown
      : 0;

    this.sticky = typeof (options.sticky !== 'undefined')
      ? options.sticky
      : false;

    this.waitForAds = typeof (options.waitForAds !== 'undefined')
      ? options.waitForAds
      : false;

    this.containerID = typeof (options.containerID !== 'undefined')
      ? options.containerID
      : false;

    this.theatreTargetMax = typeof (options.theatreTargetMax !== 'undefined')
      ? options.theatreTargetMax
      : false;

    this.theatreTargetHide = typeof (options.theatreTargetHide !== 'undefined')
      ? options.theatreTargetHide
      : false;

    this.upNext = typeof (options.upNext !== 'undefined') ? options.upNext : {};

    this.uniqueID = this.playerID + this.accountID + options.randomSeed;

    this.elements = []; // The DOM elements
    this.player = {}; // The Brightcove player object
    this.videos = []; // Brightcove video objects array
    this.playlist = false; // The Brightcove playlist object

    this.startMuted = true;

    this.ima3ScriptAvailable = false;
    this.adtechReady = false; // Set to true once header bidder has had chance to modify URL

    this.ixScriptAvailable = false;
    this.initialised = false;

    const mobileDetected = this.detectMobile();
    if (mobileDetected) {
      this.autoplay = false;
    }

    if (
      typeof window.AdblockDetectorHandler !== 'undefined' &&
      window.AdblockDetectorHandler.adblockDetected === true
    ) {
      this.autoplay = false;
    }

    this.analyticsFlags = {
      '25%': false,
      '50%': false,
      '75%': false,
    };

    this.identifyElements();

    if (
      this.theatreTargetMax &&
      this.theatreTargetHide &&
      this.elements.theatreButton &&
      this.elements.minimiseButton
    ) {
      this.elements.theatreButton.addEventListener('click', () => {
        const maxTarget = document.querySelector(this.theatreTargetMax);
        const hideTarget = document.querySelector(this.theatreTargetHide);
        if (!maxTarget || !hideTarget) return false;
        maxTarget.classList.add('po-video-player__container__theatre-modifier');
        hideTarget.classList.add('u-d-none');
        this.elements.theatreButton.setAttribute('data-is-active', 'true');
        this.elements.theatreButton.classList.add(
          'pm-video-player__extra_controls__theatre__is-active'
        );
        this.elements.theatreButton.classList.add('is-hidden');
        this.elements.minimiseButton.classList.remove('is-hidden');
      });

      this.elements.minimiseButton.addEventListener('click', () => {
        const maxTarget = document.querySelector(this.theatreTargetMax);
        const hideTarget = document.querySelector(this.theatreTargetHide);
        if (!maxTarget || !hideTarget) return false;
        maxTarget.classList.remove(
          'po-video-player__container__theatre-modifier'
        );
        hideTarget.classList.remove('u-d-none');
        this.elements.theatreButton.setAttribute('data-is-active', 'false');
        this.elements.theatreButton.classList.remove(
          'pm-video-player__extra_controls__theatre__is-active'
        );
        this.elements.theatreButton.classList.remove('is-hidden');
        this.elements.minimiseButton.classList.add('is-hidden');
      });
    }

    if (typeof this.videoIDs === 'undefined' || this.videoIDs === false) {
      this.videoIDs = [];
    }

    if (typeof this.videoID !== 'undefined' && this.videoID) {
      this.videoIDs.unshift(this.videoID);
    } else if (typeof this.videoIDs[0] !== 'undefined') {
      this.videoID = this.videoIDs[0];
    }

    // Ensures BC script is properly fetched
    const bCScriptFetched = new Promise(resolve => {
      const identifier = this.playerID + this.accountID;
      const scriptFetched = manager.isScriptFetched(identifier);
      if (scriptFetched) {
        resolve();
      } else {
        manager.fetchBCScript(this.accountID, this.playerID, resolve);
      }
    });

    const ixScriptFetched = manager.isScriptFetched('ix');
    if (ixScriptFetched) {
      this.ixFetchCallback();
    } else {
      manager.fetchIXScript(this.ixFetchCallback);
    }

    if (
      typeof window.AdManager !== 'undefined' &&
      typeof window.AdManager.callbackQueue !== 'undefined'
    ) {
      window.AdManager.queueCallback(this.adtechReadyCallback, true);
    }

    bCScriptFetched.then(() => {
      // Give the wrapper 4000ms to init all required tech once bc script is fetched. If it's still not available, then start the player without it
      setTimeout(() => {
        if (this.initialised === false) {
          console.log('triggering video player fallback timer');
          this.initialisePlayer();
        }
      }, 4000);
      const scriptFetched = manager.isScriptFetched('ima3');
      manager.fetchIMA3Script(this.ima3FetchCallback);
      // if (scriptFetched) {
      //   this.ima3FetchCallback();
      // } else {
      //   manager.fetchIMA3Script(this.ima3FetchCallback);
      // }
    });
  } // End constructor

  ixFetchCallback() {
    this.ixScriptAvailable = true;
    this.allTechReadyGo();
  }

  // Script to callback once IMA3 script is fetched. This will initialise the player
  ima3FetchCallback() {
    this.ima3ScriptAvailable = true; // Mark script as retrieved
    this.allTechReadyGo();
  }

  // Callback which fires when adtech has modified the adserver URL
  adtechReadyCallback() {
    if (!this.adtechReady) {
      this.modifyAdserverUrlWithTargeting();
    }
    this.adtechReady = true;
    this.allTechReadyGo();
  }

  allTechReadyGo() {
    if (this.initialised === true) return;
    if (this.adtechReady === false) return;
    if (this.ima3ScriptAvailable === false) return;
    if (this.ixScriptAvailable === false) return;
    // this.modifyAdserverUrlWithIxWrapper();
    this.initialisePlayer();
  }

  // Link the Brightcove player to the Video Element, and initialise all listeners, events, etc
  initialisePlayer() {
    this.initialised = true;
    console.log(`initialise player run for ${this.elements.videoEl.id}`);
    if (typeof this.videoIDs === 'object' && this.videoIDs.length > 0) {
      this.elements.videoEl.setAttribute('data-video-id', this.videoIDs[0]);
    } else if (this.playlistID) {
      this.elements.videoEl.setAttribute('data-playlist-id', this.playlistID);
    }

    if (
      typeof window.AdblockDetectorHandler !== 'undefined' &&
      window.AdblockDetectorHandler.adblockDetected === true
    ) {
      this.autoplay = false;
    }

    if (
      (this.autoplay === true || this.autoplay === 'true') &&
      this.countdown === 0 &&
      this.manager.supportsAutoplay === true
    ) {
      this.elements.videoEl.setAttribute('autoplay', 'autoplay');
      this.startMuted = false;
      this.modifyUserInitiatedTargeting(true);
    } else {
      this.elements.videoEl.removeAttribute('autoplay');
      this.autoplay = false;
      this.startMuted = false;
      this.modifyUserInitiatedTargeting(false);
    }
    if (this.autoplay === true && this.countdown > 0) {
      this.elements.autoPlayDiv.classList.add('is-visible');
    }

    this.player = window.bc(this.elements.videoEl.id);
    this.player.ima3({
      adTechOrder: ['html5'],
      timeout: 7500,
      requestMode: 'onload',
      hardTimeouts: false,
      serverUrl: this.adserverUrl,
      vpaidMode: 'ENABLED',
      debug: false,
      useMediaCuePoints: false,
    });
    this.player.on('ima3-ad-error', e => this.callbackAdsFailed(e));
    this.player.on('ads-request', this.callbackAdsRequested);
    this.player.on('ads-ad-started', this.callbackAdsStarted);
    this.player.on('ads-ad-ended', this.callbackAdsEnded);
    this.player.on('ads-pod-ended', this.callbackAdsEnded);
    this.player.on('ads-ad-skipped', this.callbackAdsEnded);
    this.player.on('play', this.callbackPlay);
    this.player.on('loadstart', this.callbackLoadMetadataStart);
    this.player.on('loadedmetadata', this.callbackLoadMetadataFinished);
    this.player.on('ended', this.callbackVideoEnded);
    this.player.on('timeupdate', this.callbackTimeUpdate);

    this.player.one('play', this.callbackFirstTimePlay);
    this.player.one('canplay', this.callbackFirstTimeIsPlayable);

    this.player.ready(() => {
      const btnElement = document.getElementById(
        `video-player-${this.playerID}__extra-controls`
      );

      const controlBarElements = this.elements.containerInner.getElementsByClassName(
        'vjs-control-bar'
      );
      let controlBarElement = false;
      if (controlBarElements) {
        controlBarElement = controlBarElements[0];
      }

      const fullScreenElements = this.elements.containerInner.getElementsByClassName(
        'vjs-fullscreen-control'
      );
      let fullScreenElement = false;
      if (fullScreenElements) {
        fullScreenElement = fullScreenElements[0];
      }

      if (btnElement && controlBarElement && fullScreenElement) {
        btnElement.style.display = 'inline-block';
        controlBarElement.insertBefore(btnElement, fullScreenElement);
      }
    });

    this.fetchVideos();
  }

  // TODO - Verify that this works correctly
  modifyAdserverUrlWithTargeting() {
    if (typeof window.AdManager === 'undefined') return;

    const globalTargeting = window.AdManager.globalTargeting;
    // let adParams = '';
    let queryString = Object.keys(globalTargeting)
      .map(
        key =>
          `${encodeURIComponent(key)}%3D${encodeURIComponent(
            globalTargeting[key]
          )}`
      )
      .join('%26');

    if (queryString.length > 0) {
      queryString = "&cust_params=" + `${queryString}`;
    }

    this.adserverUrl += queryString;
  }

  // Changes adserverURL targeting param for isAutoplay to true or false
  modifyUserInitiatedTargeting(param) {
    let isUserInit = param;
    if (typeof param === 'undefined') {
      isUserInit = false;
    } else if(param !== true && param !== false) {
      isUserInit = false;
    }

    let isUserInitString = "true";
    if(isUserInit !== true) {
      isUserInitString = "false";
    }

    const gamKey = 'user_initiated';

    if(this.adserverUrl.indexOf(`%26${gamKey}%3Dtrue`) > -1) {
      this.adserverUrl = this.adserverUrl.replace(`%26${gamKey}%3Dtrue`, `%26${gamKey}%3D${isUserInitString}`);
    } else if (this.adserverUrl.indexOf(`%26${gamKey}%3Dfalse`) > -1) {
      this.adserverUrl = this.adserverUrl.replace(`%26${gamKey}%3Dfalse`, `%26${gamKey}%3D${isUserInitString}`);
    } else {
      this.adserverUrl += `%26${gamKey}%3D${isUserInitString}`;
    }
  }

  // Modifies the Adserver URL so that it is wrapped in IX Tags
  modifyAdserverUrlWithIxWrapper() {
    if (
      typeof window.getIndexTag === 'function' &&
      typeof window.indexConfig !== 'undefined'
    ) {
      this.adserverUrl = window.getIndexTag(
        this.adserverUrl,
        window.indexConfig
      );
    }
  }

  // Fetch videos from Brightcove
  fetchVideos() {
    let videoFetches = 0;
    if (typeof this.videoIDs === 'object' && this.videoIDs.length > 0) {
      this.videoIDs.forEach(id => {
        this.player.catalog.getVideo(id, (error, video) => {
          if (error) {
            console.log(error);
          } else {
            this.videos.unshift(video);
          }
          videoFetches++;
          if (videoFetches === this.videoIDs.length) {
            this.callbackAllVideosFetched();
          }
        });
      });
    } else {
      this.callbackAllVideosFetched();
    }
  }

  // Fetch a playlist from Brightcove
  fetchPlaylist() {
    this.player.catalog.getPlaylist(this.playlistID, (error, returned) => {
      if (error && !this.playlist) {
        console.log(error);
        this.playlistID = false;
      } else {
        this.playlist = returned;
      }
      this.buildPlaylist();
    });
  }

  // Combine fetched videos with fetched playlist and create a playlist which feeds into the player
  buildPlaylist() {
    if (this.playlist) {
      let iterator = 0;
      this.playlist.forEach(item => {
        const playlistVideoID = item.id;
        this.videoIDs.forEach(videoID => {
          if (playlistVideoID === videoID) {
            this.playlist.splice(iterator, 1);
          }
        });
        iterator++;
      });
    } else {
      this.playlist = [];
    }

    // If there's any explicitly declared video elements, add them to the front of the playlist
    if (this.videos) {
      this.videos.forEach(video => {
        this.playlist.unshift(video);
      });
    }

    // If after all that, the playlist is still empty, then throw an error
    if (this.playlist.length === 0) {
      console.log(
        'No valid media could be found. Player could not initialise.'
      );
    }

    // Set the brightcove playlist so that it matches the wrapper's playlist
    this.player.playlist(this.playlist);

    // Wait 8 sec after video end before advancing to the next video
    this.player.playlist.autoadvance(null);

    if (this.player.playlist().length > 0) {
      this.readyUpFrontend();
    } else {
      this.failUpFrontend();
    }
  }

  // Final method to be called once processing is done. Populates relevant divs, hides unnecessary ones, etc
  readyUpFrontend() {
    this.modifyElement('titleDiv', this.playlist[0].name);
    this.elements.overlayDiv.classList.add('is-visible');
    this.elements.titleDiv.classList.add('is-visible');
    if (this.sticky === true) {
      this.setUpIntersectionObservers();
    }
    this.setUpResizeListener();
    if (this.manager.supportsAutoplay === true && this.autoplay === true) {
      if (
        (typeof window.AdblockDetectorHandler !== 'undefined' &&
          window.AdblockDetectorHandler.adblockDetected === false) ||
        typeof window.AdblockDetectorHandler === 'undefined'
      ) {
        this.startAutoplayCountdown();
        this.elements.autoPlayCancel.onclick = () => {
          this.stopAutoplayTick();
        };
      }
    }
  }

  // Build the Up Next overlay
  buildUpNext() {
    // If upNext is not explicitly defined, then make one up using playlists (if applicable)
    if (this.upNext === null || this.upNext === false) {
      const currentPlaylistPosition = this.player.playlist.currentIndex();
      const totalPlaylistSize = this.player.playlist().length;
      if (totalPlaylistSize > currentPlaylistPosition + 1) {
        const bestImage = this.player.playlist()[currentPlaylistPosition + 1]
          .poster;
        const newTitle = this.player.playlist()[currentPlaylistPosition + 1]
          .name;
        this.elements.upNextContainer.style.backgroundImage = `url(${bestImage})`;
        this.elements.upNextTitle.innerHTML = newTitle;
        this.elements.upNextAuthor.innerHTML = '';
        this.elements.upNextNext.onclick = () => {
          this.player.playlist.next();
        };
      }
    } else {
      // Otherwise, just get the next item in the list to play
      let bestImage = false;
      if (this.upNext.image) {
        this.upNext.image.renditions.forEach(rendition => {
          if (rendition.size === 'video-poster') {
            bestImage = rendition.url;
          }
        });
      } else {
        bestImage = '';
      }

      if (!bestImage) {
        bestImage = this.upNext.image.original_url;
      }

      this.elements.upNextTitle.innerHTML = this.upNext.title;
      this.elements.upNextContainer.style.backgroundImage = `url(${bestImage})`;
      this.elements.upNextAuthor.innerHTML = this.upNext.author.display_name;
      this.elements.upNextNext.onclick = () => {
        if (typeof window.pjax !== 'undefined') {
          window.pjax.loadUrl(this.upNext.URL);
        } else {
          window.location.href = this.upNext.URL;
        }
      };
    }

    this.elements.upNextCancel.onclick = () => {
      this.player.playlist.autoadvance(null);
      this.stopUpNextTick();
    };
    this.elements.upNextReplay.onclick = () => {
      this.player.playlist.autoadvance(null);
      this.stopUpNextTick();
      this.player.currentTime(0);
      this.player.play();
    };
  }

  tickUpNext() {
    this.elements.autoPlayDiv.classList.add('is-visible');
    this.upNextCountdown = 8;
    this.elements.upNextTimer.innerHTML = this.upNextCountdown;
    this.elements.upNextTimer.classList.add('is-visible');
    this.upNextInterval =
      this.upNextInterval ||
      setInterval(() => {
        this.upNextCountdown--;
        if (this.upNextCountdown === 0) {
          this.elements.upNextTimer.innerHTML = '0';
          if (this.upNext && this.upNext.URL && this.playerIsInView()) {
            if (typeof window.pjax !== 'undefined') {
              window.pjax.loadUrl(this.upNext.URL);
            } else {
              window.location.href = this.upNext.URL;
            }
          } else {
            this.stopUpNextTick();
          }
        } else {
          this.elements.upNextTimer.innerHTML = this.upNextCountdown;
        }
      }, 1050);
  }

  playerIsInView() {
    if (!this.elements.videoEl) return false;
    const bounding = this.elements.videoEl.getBoundingClientRect();
    if (!bounding) return false;
    if (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight)
    ) {
      return true;
    }
    return false;
  }

  stopUpNextTick() {
    clearInterval(this.upNextInterval);
    this.upNextInterval = false;
    this.elements.upNextTimer.classList.remove('is-visible');
  }

  // Show error messages for failed video load
  failUpFrontend() {
    console.log('failed to load video player due to lack of media');
  }

  // Callback which fires once all videos requested have been fetched
  callbackAllVideosFetched() {
    if (this.playlistID) {
      this.fetchPlaylist();
    } else {
      this.buildPlaylist();
    }
  }

  // Ticks down autoplay, both visually and functionally
  startAutoplayCountdown() {
    this.autoplayInterval =
      this.autoplayInterval ||
      setInterval(() => {
        this.countdown--;
        this.elements.autoPlayTimer.innerHTML = this.countdown;
        if (this.countdown <= 0) {
          if (this.startMuted) {
            this.elements.videoEl.setAttribute('muted', 'muted');
            this.player.muted(true);
          }

          this.stopAutoplayTick();
          // Only autoplay if we know for a fact that autoplay is supported
          if (this.manager.supportsAutoplay === true) {
            this.player.play();
          }
        }
      }, 1050);
  }

  stopAutoplayTick() {
    clearInterval(this.autoplayInterval);
    this.elements.autoPlayDiv.classList.remove('is-visible');
    this.autoplayInterval = false;
  }

  // If someone resizes the window, pause the player and the ad if containerOuter does not have .is-fixed
  setUpResizeListener() {
    window.addEventListener('resize', this.resizeCallback);
  }

  resizeCallback() {
    return; // Stopping execution for now
    if (
      window.innerWidth < 992 &&
      this.elements.containerOuter.classList.contains('is-fixed')
    ) {
      this.stopAutoplayTick();
      console.log('PAUSING');
      this.player.pause();
      if (this.player.ads.isAdPlaying()) {
        console.log('PAUSING');
        this.player.ima3.adPlayer.pause();
      }
    }
  }

  setUpIntersectionObservers() {
    const options = {
      root: null,
      rootMargin: '0px 0px -100px 0px',
      threshold: 0,
    };
    try {
      this.observer = new IntersectionObserver(
        this.intersectionCallback,
        options
      );
      this.observer.observe(this.elements.containerOutermost);
    } catch (err) {
      console.log('Sticky video not supported');
    }
  }

  intersectionCallback(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        this.elements.containerOuter.classList.remove('is-fixed');
        this.elements.containerMedian.classList.remove('is-fixed');
        this.elements.containerInner.classList.remove('is-fixed');
      } else {
        if (window.innerWidth < 992) {
          this.stopAutoplayTick();
          this.player.pause();
          if (this.player.ads.isAdPlaying()) {
            this.player.ima3.adPlayer.pause();
          }
        }
        this.elements.containerOuter.classList.add('is-fixed');
        this.elements.containerMedian.classList.add('is-fixed');
        this.elements.containerInner.classList.add('is-fixed');
      }
    });
  }

  // Callback which fires when BC triggers an ads requested event
  callbackAdsRequested() {}

  // Callback which fires when BC triggers an ads started event
  callbackAdsStarted() {
    // NOTE - Don't pause the main player. This causes issues on iOS devices.
    // this.player.pause();
  }

  // Callback which fires when BC triggers an ads ended event
  callbackAdsEnded() {
    this.player.play();
  }

  // Callback which fires when the IMA3 plugin identifies that an ad has failed to load
  callbackAdsFailed(e = false) {
    console.log('AD ERROR FIRED');
    console.log(e);
    // TODO - Need to implement a recover method to force-quit ima3
  }

  // Callback which fires when BC starts the selected video
  callbackPlay() {
    console.log('CALLBACK PLAY');
    this.buildUpNext();
    // Set the auto-advance countdown
    if (this.player.playlist()) {
      this.upNextCountdown = 8;
      this.player.playlist.autoadvance(this.upNextCountdown);
    }
    this.elements.overlayDiv.classList.remove('is-visible');
    this.elements.upNextContainer.classList.remove('is-visible');
  }

  // Callback which fires whenever a timeupdate event fires in the player
  callbackTimeUpdate() {
    const videoLength = this.player.mediainfo.duration;
    const currentTime = this.player.currentTime();

    if (videoLength === 0 || currentTime === 0) {
      return;
    }

    const isInIframe = parent !== window;
    let parentUrl = window.location.href;
    if (isInIframe) {
      parentUrl = document.referrer;
    }

    const currentPercentage = currentTime / videoLength;
    if (currentPercentage >= 0.23 && this.analyticsFlags['25%'] === false) {
      this.analyticsFlags['25%'] = true;
      window.ArnAnalytics.customEvent({
        category: 'Video Player',
        action: 'Video 25% Reached',
        label: this.videoID,
        customUrl: parentUrl,
      });
    } else if (
      currentPercentage >= 0.48 &&
      currentPercentage <= 0.52 &&
      this.analyticsFlags['50%'] === false
    ) {
      this.analyticsFlags['50%'] = true;
      window.ArnAnalytics.customEvent({
        category: 'Video Player',
        action: 'Video 50% Reached',
        label: this.videoID,
        customUrl: parentUrl,
      });
    } else if (
      currentPercentage >= 0.73 &&
      currentPercentage <= 0.77 &&
      this.analyticsFlags['75%'] === false
    ) {
      this.analyticsFlags['75%'] = true;
      window.ArnAnalytics.customEvent({
        category: 'Video Player',
        action: 'Video 75% Reached',
        label: this.videoID,
        customUrl: parentUrl,
      });
    }
  }

  // Callback which fires the very first time BC starts a video. Will not fire twice in one pageview
  callbackFirstTimePlay() {
    const isInIframe = parent !== window;
    let parentUrl = window.location.href;
    if (isInIframe) {
      parentUrl = document.referrer;
    }

    window.ArnAnalytics.customEvent({
      category: 'Video Player',
      action: 'Video Start',
      label: this.videoID,
      customUrl: parentUrl,
    });
    this.analyticsFlags = {
      '25%': false,
      '50%': false,
      '75%': false,
    };
  }

  // Callback which fires when BC begins loading metadata
  callbackLoadMetadataStart() {}

  // Callback which fires when BC finishes loading metadata
  callbackLoadMetadataFinished() {}

  // Callback which fires when BC determines that the initial video is playable. This creates schema for the video (if it doesn't already exist)
  callbackFirstTimeIsPlayable() {
    console.log('FIRING FIRST TIME IS PLAYABLE CALLBACK! ');
  }

  // Callback which fires when the selected video finishes playing (reaches its end time)
  callbackVideoEnded() {
    const isInIframe = parent !== window;
    let parentUrl = window.location.href;
    if (isInIframe) {
      parentUrl = document.referrer;
    }

    window.ArnAnalytics.customEvent({
      category: 'Video Player',
      action: 'Video Finish',
      label: this.videoID,
      customUrl: parentUrl,
    });
    this.elements.overlayDiv.classList.add('is-visible');
    this.elements.upNextContainer.classList.add('is-visible');
    if (
      this.player.playlist.currentIndex() + 1 !==
        this.player.playlist().length ||
      this.upNext
    ) {
      this.tickUpNext();
    }
  }

  // Populate an element's inner HTML value
  modifyElement(element, value) {
    this.elements[element].innerHTML = value;
  }

  // Modify the divs already on the page with Brightcove data
  identifyElements() {
    this.elements.containerDiv = document.querySelector(
      `${this.containerID}__video`
    );
    this.elements.containerOutermost = document.querySelector(
      `${this.containerID}__container-outermost`
    );
    this.elements.containerOuter = document.querySelector(
      `${this.containerID}__container-outer`
    );
    this.elements.containerMedian = document.querySelector(
      `${this.containerID}__container-median`
    );
    this.elements.containerInner = document.querySelector(
      `${this.containerID}__container-inner`
    );

    this.elements.overlayDiv = document.querySelector(
      `${this.containerID}__overlay`
    );

    this.elements.autoPlayDiv = document.querySelector(
      `${this.containerID}__autoplay-container`
    );
    this.elements.autoPlayTimer = document.querySelector(
      `${this.containerID}__autoplay-countdown`
    );
    this.elements.autoPlayCancel = document.querySelector(
      `${this.containerID}__autoplay-cancel`
    );

    this.elements.upNextContainer = document.querySelector(
      `${this.containerID}__up-next-container`
    );
    this.elements.upNextTitle = document.querySelector(
      `${this.containerID}__up-next-title`
    );
    this.elements.upNextAuthor = document.querySelector(
      `${this.containerID}__up-next-author`
    );
    this.elements.upNextTimer = document.querySelector(
      `${this.containerID}__up-next-timer`
    );
    this.elements.upNextReplay = document.querySelector(
      `${this.containerID}__up-next-replay`
    );
    this.elements.upNextCancel = document.querySelector(
      `${this.containerID}__up-next-cancel`
    );
    this.elements.upNextNext = document.querySelector(
      `${this.containerID}__up-next-next`
    );

    this.elements.titleDiv = document.querySelector(
      `${this.containerID}__title-container`
    );
    this.elements.videoEl = document.querySelector(
      `${this.containerID}__video`
    );
    this.elements.theatreButton = document.querySelector(
      `${this.containerID}__theatre-on`
    );
    this.elements.minimiseButton = document.querySelector(
      `${this.containerID}__theatre-off`
    );
  }

  // A quick and dirty mobile detect script. Not perfect, but should help us prevent 90% of mobile autoplays
  detectMobile() {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    }

    return false;
  }
}

export default (options, manager) => new videoPlayer(options, manager);
